// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"bdc5b7ed","977":"c9d7a00a"}[chunkId] + ".chunk.js";
};